<template>
    <div>
        <h2 class='subtitle is-dark'>
            マッチング相手選択画面
        </h2>
        <div v-if="isFirst&&isSecond&&isThird">開票までしばらくお待ちください....(結果発表をクリック)</div>
        <div v-else>
            <div v-if="entries.length> 1">気に入ったを選んでください</div>
            <div v-else>あなた以外誰もいません...</div>
        </div>
        <div class='box'>
            <!-- item.aは存在しないが、警告がでるので使用 -->
            <div  v-for="item in entries" :key="item.a">
                <div class="panel-block member" :class="changeColor(key)" v-for="(val, key) in item"
                :key="val" :id="key" @click="dialog(key, val)">
                    <span class="panel-icon">
                        <i class="fas fa-user" aria-hidden="true"></i>
                    </span>
                    <span>{{val}}</span>
                    <span class="right" v-if="key === isFirst">①</span>
                    <span class="right" v-if="key === isSecond">②</span>
                    <span class="right" v-if="key === isThird">③</span>
                </div>
            </div>
        </div>
        <button class='button is-light' @click="goHome" >
            <span class='icon'>
                <i class="fas fa-home"></i>
            </span>
            <span>戻る</span>
        </button>
    </div>
</template>

<script>
// なぜか動かないのでここで読み込む
import { Toast } from 'buefy/dist/components/toast'
import Choose from '@/views/Trial/Choose.vue'
export default {
    data(){
        return{
            entries: [],
            item: "",
            isFirst: "",  // 第1候補
            isSecond: "", // 第2候補
            isThird: "",  // 第3候補
        }
    },
    created(){
        this.entries.push(
            {"1":"広瀬 すず"},
            {"2":"山﨑 賢人"},
            {"3":"菅田 将暉"},//マッチングしない
            {"4":"土屋 太鳳"},//マッチングしない
            {"5":"橋本 環奈"},
            {"6":"新垣 結衣"},
            {"7":"窪田 正孝"},//マッチングしない
            {"8":"高橋 一生"},
            {"9":"長澤まさみ"},
        );
        this.$toast.open({
            duration: 4000,
            message: `[チュートリアル]  気になる人を押してみましょう！`,
            position: 'is-top',
            type: 'is-info'
        })
    },
    methods:{
        dialog: function(id, name){
            this.$modal.open({
                parent: this,
                component: Choose,
                props:{
                    id: id,
                    name:  name,
                    parentSelection: {
                        isFirst:  (this.isFirst === id)?  true: false,
                        isSecond: (this.isSecond === id)? true: false,
                        isThird:  (this.isThird === id)?  true: false,
                    }
                    
                },
                // Buefyのモーダルでは以下でイベントを渡す
                events: {
                    "confirm": (key, id)=>this.setSelection(key, id),
                }
            });
        },
        setSelection: function(key, id){
            // 重複を消す
            if(this.isFirst === id) this.isFirst = "";
            if(this.isSecond === id)this.isSecond = "";
            if(this.isThird === id) this.isThird = "";
            // セット
            if(key){
            this[key] = id;
            }
            this.$emit("setEntry", this.entries, this.isFirst, this.isSecond, this.isThird);
        },
        changeColor: function(id){
            let color = "";
            switch(id){
                case this.isFirst:
                color = "first";
                break;
                case this.isSecond:
                color = "second";
                break;
                case this.isThird:
                color = "third";
                break;
                default:
                color = "normal"
                break;
            }
            return color;
        },
        goHome: function(){
            this.$router.push(`/`);
        }
    }
}
</script>

<style scoped>
.member       {
    cursor: pointer;
    position: relative;
    }
.first        {background: #ECACB5;}
.first:hover  {background: #E38692;}
.fisrt:active {background: #DA6272;}
.second       {background: #F9E3AA;}
.second:hover {background: #F6D580;}
.second:active{background: #F3C759;}
.third        {background: #A6E39D;}
.third:hover  {background: #81D674;}
.third:active {background: #5EC84E;}
.normal:hover {background: #eeeeee;}
.normal:active{background: #dddddd;}
.right{
    position: absolute;
    right: 15px;
}
</style>
